<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BSidebar
      id="sbRsmCustomer"
      backdrop-variant="dark"
      backdrop
      shadow
      right
    >
      <template #title>
        <i class="fad fa-filter-list" /> Filters
      </template>

      <BContainer>
        <BRow>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Area"
              label-for="filterArea"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.area"
                placeholder="filter area here"
                input-id="filterArea"
                label="area_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableCustomers.options.areas)"
                :loading="(tableCustomers.fetching.areas)"
                :disabled="(tableCustomers.busy || tableCustomers.fetching.areas)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterAreas"
              >
                <template #no-options="">
                  no available area
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Cluster"
              label-for="filterCluster"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableCustomers.selected.cluster"
                placeholder="filter cluster here"
                input-id="filterCluster"
                label="cluster_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableCustomers.options.clusters)"
                :loading="(tableCustomers.fetching.clusters)"
                :disabled="(tableCustomers.busy || tableCustomers.fetching.clusters)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterClusters"
              >
                <template #no-options="">
                  no available cluster
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>

        </BRow>
      </BContainer>
    </BSidebar>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BInputGroup>
            <BFormInput
              id="filterSearch"
              v-model="tableCustomers.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
            <BInputGroupAppend>
              <BButton
                v-b-toggle.sbRsmCustomer
                variant="primary"
              >
                <i
                  v-if="[settingFilters, tableCustomers.fetching.clusters].some(trueOrFalse => trueOrFalse)"
                  class="fad fa-spinner fa-spin p-0"
                />
                <i
                  v-else
                  class="fad fa-filter-list"
                /> Filters
              </BButton>
            </BInputGroupAppend>
          </BInputGroup>
        </BFormGroup>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableCustomers"
      :provider="tableProvider"
      :fields="tableCustomers.fields"
      :filter="tableCustomers.filter"
      :filter-on="tableCustomers.filterOn"
      :sort-by="tableCustomers.sortBy"
      :sort-desc="tableCustomers.sortDesc"
      :sort-direction="tableCustomers.sortDirection"
      :total-rows="tableCustomers.totalRows"
      :current-page="tableCustomers.currentPage"
      :per-page="tableCustomers.perPage"
      :stacked="tableCustomers.stacked"
      :busy="tableCustomers.busy"
    >

      <template #cell(action)="{ item }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
          <BButton
            size="sm"
            variant="primary"
            :disabled="tableCustomers.busy"
            :to="{
              name: 'rsm.customers.profile',
              params: {
                customer: item.id
              }
            }"
          >
            Manage
          </BButton>
        </div>
      </template>

      <template #cell(customer_name)="{ item }">
        <div class="d-flex flex-column gap-1 p-1">
          <div class="font-weight-bolder">
            {{ item.customer_name }}
          </div>
          <div style="font-size: 10px;">
            {{ item.address }}
          </div>
        </div>
      </template>
    </CustomTable>

  </BContainer>
</template>
<script>
import QUERY from 'lodash'
import { mapGetters } from 'vuex'
import { setTableOptions, getTableOptions } from '@/forage/rsm/customers'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MAreas from '@/mixins/locations/areas'
import MClusters from '@/mixins/locations/clusters'

import { SRSMCustomer } from '@/services/rsm'

export default {

  name: 'RSMCustomers',

  mixins: [
    MAreas,
    MClusters,
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  beforeRouteEnter (_to, _from, navigate) {
    getTableOptions().then(options => {
      navigate(context => {
        if (context.currentUser) {
          if (options) {
            const { currentPage, perPage, sortBy, sortDesc, totalRows, filter } = options

            context.tableCustomers = Object.assign(context.tableCustomers, {
              totalRows: totalRows || 0,
              sortBy: sortBy || 'id',
              sortDesc: sortDesc || false,
              perPage: perPage || 10,
              currentPage: currentPage || 0,
              filter: {
                search: filter.search || '',
                area: '',
                cluster: '',
                status: filter?.status || 'All'
              },
              editable: {
                area: filter?.area || '',
                cluster: filter?.cluster || ''
              }
            })
          } else {
            context.tableCustomers.currentPage = 1
          }

          context.$nextTick(() => {
            context.getAreas(context.tableCustomers, '', context.currentUser.team).finally(() => {
              if (context.tableCustomers.editable.area) {
                context.tableCustomers.selected.area = QUERY.find(context.tableCustomers.options.areas, {
                  id: context.tableCustomers.editable.area
                }) || ''

                context.tableCustomers.editable.area = ''
              } else {
                context.getClusters(context.tableCustomers).finally(() => {
                  if (context.tableCustomers.editable.cluster) {
                    context.tableCustomers.selected.cluster = QUERY.find(context.tableCustomers.options.clusters, {
                      id: context.tableCustomers.editable.cluster
                    }) || ''

                    context.tableCustomers.editable.cluster = ''
                  }
                })
              }
            })
          })
        }
      })
    })
  },

  middleware: [
    'auth',
    'rsm'
  ],

  metaInfo: () => ({
    title: 'Customers'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false,
        settings: false
      },
      tableCustomers: {
        busy: false,
        fetching: {
          areas: false,
          clusters: false
        },
        options: {
          yesOrNos: [
            { value: 'All', text: 'All' },
            { value: 1, text: 'Yes' },
            { value: 0, text: 'No' }
          ],
          areas: [],
          clusters: []
        },
        editable: {
          area: '',
          cluster: ''
        },
        selected: {
          tagging: 1,
          area: '',
          cluster: ''
        },
        filter: {
          search: '',
          area: '',
          cluster: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 0,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          { mobile: 7, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'customer_name', label: 'Customer', class: 'min-w-md-250px', sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    settingFilters () {
      const hasEditables = Object.keys(this.tableCustomers.editable).map(
        editableKey => this.tableCustomers.editable[editableKey]
      ).some(val => String(val) !== '')

      return hasEditables
    }
  },

  watch: {
    'tableCustomers.selected.area' (area) {
      this.tableCustomers.filter.area = area?.id || ''
    },

    'tableCustomers.selected.cluster' (cluster) {
      this.tableCustomers.filter.cluster = cluster?.id || ''
    },

    'tableCustomers.filter.area' (area) {
      this.getClusters(this.tableCustomers, '', area).finally(() => {
        if (this.tableCustomers.editable.cluster) {
          this.tableCustomers.selected.cluster = QUERY.find(this.tableCustomers.options.clusters, {
            id: this.tableCustomers.editable.cluster
          }) || ''

          this.tableCustomers.editable.cluster = ''
        }
      })
    }
  },

  methods: {
    customerStatus (status) {
      switch (status) {
        case 'Verified': {
          return 'secondary'
        }
        case 'New': {
          return 'primary'
        }
        default: {
          return 'warning'
        }
      }
    },

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      if (this.settingFilters) {
        return []
      }

      this.tableCustomers.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        area_id: filter.area,
        cluster_id: filter.cluster
      }

      return await SRSMCustomer.get(payload).then(
        ({ data }) => {
          this.tableCustomers.totalRows = data.total_rows
          setTableOptions({
            currentPage,
            perPage,
            sortBy,
            sortDesc,
            filter,
            totalRows: data.total_rows
          })
          return data.items
        }
      ).catch(
        () => {
          this.tableCustomers.totalRows = 0
          setTableOptions({
            currentPage,
            perPage,
            sortBy,
            sortDesc,
            filter,
            totalRows: 0
          })
          return []
        }
      ).finally(() => {
        this.tableCustomers.busy = false
      })
    },

    async searchFilterAreas (search, loading) {
      this.searchAreasProvider(this.tableCustomers, search, loading)
    },

    async searchFilterClusters (search, loading) {
      this.searchClustersProvider(this.tableCustomers, search, loading)
    }
  }
}
</script>
